import React from "react";
import { Modal, Close, Header } from "MODULES/shared/components/Modal";
import { useCurrentUser } from "APP_ROOT/hooks";
import Form from "./Form";

function SendRepairOrderDocumentsModal({ open, close, repairOrder }) {
  const currentUser = useCurrentUser();

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Are You Sure?</h4>
      </Header>
      <Form close={close} currentUser={currentUser} repairOrder={repairOrder} />
    </Modal>
  );
}

export default SendRepairOrderDocumentsModal;



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/SendRepairOrderDocuments/SendRepairOrderDocumentsModal.jsx